import React, { useState, useEffect } from "react";
import { FormattedDate, FormattedTime } from "react-intl";
import { Badge, Table } from "reactstrap";
import style from "./../style.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { CustomHandlers } from "../types";
import InfiniteScroll from "react-infinite-scroller";
import { localDateTime } from "../../../utils/Helper";

const Grid = ({ grid, getEvents, setRead, routes = {}, ...props }) => {
  const [redirect, setRedirect] = useState(null);

  useEffect(() => {
    getEvents(0);
  }, []);

  const handleRowClick = (event) => {
    setRead({ id: event.id });

    if (CustomHandlers.includes(event.process)) {
    } else {
      const { to } = routes[event.process] || { to: "/" };
      setRedirect({
        pathname: to,
        state: {
          id: event.processId,
          hash: Math.random().toString(36).substring(2, 10),
        },
      });
    }
  };

  if (redirect) {
    return <props.redirect to={{ ...redirect }} />;
  }

  return [
    <div key="events-grid" className={style.grid}>
      <InfiniteScroll
        pageStart={0}
        loader={
          <div className="loader" key={0}>
            {true ? <CircularProgress sm /> : null}
          </div>
        }
        loadMore={getEvents}
        hasMore={grid.hasMore}
      >
        <Table striped hover>
          <thead>
            <tr>
              <th>Process</th>
              <th></th>
              <th>Datetime</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {grid.events == null || grid.events.length == 0 ? (
              <EmptyTable loading={grid.events == null} />
            ) : (
              grid.events.map((event) => {
                const isFailed = event.process === "Offer" && !event.read && event.text.includes("#Failed#");
                const cleanText = event.text.replace(/#Failed#|#Success#/g, "").trim();
                return (
                  <tr
                    key={`event-${event.id}`}
                    className={isFailed ? 'table-danger' : ''}
                    onClick={() => handleRowClick(event)}
                  >
                    <td>
                      <strong>{event.process}</strong>
                    </td>
                    <td>{!event.read && <Badge color="success">Unread</Badge>}</td>
                    <td>
                      <Datetime value={event.dateTime} />
                    </td>
                    <td>{cleanText}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </InfiniteScroll>
    </div>,
  ];
};

export const Datetime = ({ value }) => {
  if (value == undefined) return <span>-</span>;
  return (
    <span>
        <FormattedDate value={localDateTime(value)} />{" "}
        <FormattedTime value={localDateTime(value)} hour12={false} />
    </span>
  );
};

const EmptyTable = ({ loading }) => (
  <tr className={style.empty}>
    <td colSpan="4" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No events</h4>
      )}
    </td>
  </tr>
);

const progressStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  bottom: "30px",
  right: 0,
  margin: "auto",
};

export default Grid;
